/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { OTLPExporterConfigBase } from './legacy-base-configuration';
import { wrapStaticHeadersInFunction } from './shared-configuration';
import { HeadersFactory } from './otlp-http-configuration';

export function convertLegacyHeaders(
  config: OTLPExporterConfigBase
): HeadersFactory | undefined {
  if (typeof config.headers === 'function') {
    return config.headers;
  }
  return wrapStaticHeadersInFunction(config.headers);
}
